import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, Input, inject } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioButton, MatRadioModule } from "@angular/material/radio";
import { MatTableModule } from "@angular/material/table";
import {
  IAcuerdo,
  IAcuerdoSeleccionado,
  SIAcuerdoSeleccionado,
} from "../../../interfaces/acuerdos";
import { LoadingService } from "../../../loading/loading.service";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import { DetalleTemaComponent } from "../detalle-tema/detalle-tema.component";

import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import {
  MatDatepicker,
  MatDatepickerModule,
} from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Store, select } from "@ngrx/store";
import * as moment from "moment";
import {
  Observable,
  Subject,
  catchError,
  firstValueFrom,
  of,
  pairwise,
  switchMap,
  take,
  takeUntil
} from "rxjs";
import { AcuerdoMrbService } from "../../../acuerdo-mrb/acuerdo-mrb.service";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { IListaTemas } from "../../../interfaces/doownloadFile";
import { IDetalleTema } from "../../../interfaces/temas";
import { CreateDownloadFile } from "../../../services/crate-download-file/crate-download-file.service";
import { StorageService } from "../../../services/storage/files.service";
import { expandAcuerdo } from "../../../states/acuerdos-mrb/actions";
import {
  selectAcuerdoActualById,
  selectAcuerdoById,
  selectAcuerdoHistoricoById,
  selectAllAcuerdos,
  selectTipoAcuerdo,
} from "../../../states/acuerdos-mrb/selector";
import {
  cargaTemasAcuerdo,
  updateFechaAcuerdo
} from "../../../states/temas/actions";
import {
  selectAcuerdoSelected,
  selectStatusAcuerdo,
} from "../../../states/temas/selectors";
import {
  selectTemasUsuario,
  selectUsuario,
} from "../../../states/usuario/selector";
import { iTema } from "../../../usuario/usuario.interface";
import { NuevoTemaComponent } from "../nuevo-tema/nuevo-tema.component";
import { AcuerdosUtilsService } from "../utils";
import { getUserRoles } from "./fixtures";
import { cargarEntradas } from "../../../states/entradas/actions";

export interface todosEntrada {
  id: string;
  indiceTema: number;
  categorizacion: string;
  fechaAcuerdo: string;
  archivos: any;
}

@Component({
  selector: "app-table-mrb",
  standalone: true,
  imports: [
    MatCardModule,
    MatTableModule,
    CommonModule,
    MatIconModule,
    MatRadioModule,
    //MatRadioButton,
    FormsModule,
    ScrollingModule,
    DetalleTemaComponent,
    MatButtonModule,
    NuevoTemaComponent,
    MatDatepickerModule,
    MatInputModule,
    MatTooltipModule,
  ],
  templateUrl: "./table-mrb.component.html",
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "es-MX" },
    provideNativeDateAdapter(),
  ],
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  styleUrl: "./table-mrb.component.css",
})
export class TableMrbComponent {
  @Input() data!: IAcuerdo[];
  expandedElement!: IAcuerdo | null;
  columnsToDisplay: string[] = [
    "No",
    "fechaAcuerdo",
    "temas",
    "archivoUnico",
    "descargar",
  ];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, "expand"];

  elemmentID = null;
  element: any;
  elementoSeleccionado = null;
  detalleTemaSeleciionado = [];
  abrirCalendario = false;
  fechAcuerdo = new Date();


  temas: IDetalleTema[] = [];
  rolesAcuerdo$!: Observable<number>;
  temasUsuario$!: Observable<{ [key: string]: iTema }>;
  acuerdoSeleccionado$!: Observable<IAcuerdoSeleccionado>;
  selectedAcuerdoById$!: Observable<IAcuerdo | undefined>;
  selectedAcuerdoSelectById$!: Observable<IAcuerdo | undefined>;
  selectedAcuerdoHistoricoById$!: Observable<IAcuerdo | undefined>;
  fechaSeleccionada = "";
  rolesUsuario: { [key: string]: iTema } = {};
  tipoAcuerdo$!: Observable<number>;
  tipoAcuerdo: number = 0;
  acuerdoSeleccionado!: IAcuerdo | undefined;
  selectStatusAcuerdo$: Observable<string>;
  public temasAcuerdo!: FormGroup;
  private stateUser: any = this.store.pipe(select(selectUsuario));
  private readonly stateTipoAcuerdo: any = this.store.pipe(
    select(selectAllAcuerdos)
  );
    private destroy$ = new Subject<void>();

    
  public catTipoTema: any[] = [];
  public catCategorizacion: any[] = [];
  private acuerdoMrbService = inject(AcuerdoMrbService);
  private temaModificado: number |string| null = null;
  constructor(
    private acuerdosService: AcuerdosService,
    private loadingService: LoadingService,
    private createDawnloadFile: CreateDownloadFile,
    private storageService: StorageService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private acuerdosUtils: AcuerdosUtilsService,
    private cdr: ChangeDetectorRef
  ) {
    this.temasAcuerdo = this.fb.group({
      temas: this.fb.array([]),
      acuerdo: this.fb.group({}),
    });
    this.rolesAcuerdo$ = of(0);
    this.acuerdoSeleccionado$ = of(SIAcuerdoSeleccionado);
    this.temasUsuario$ = of({});
    this.tipoAcuerdo$ = of(0);
    this.selectStatusAcuerdo$ = of("");
  }

  async ngOnInit() {
    this.rolesAcuerdo$ = this.store.select(selectTipoAcuerdo);
    this.store
      .select(selectAcuerdoSelected)
      .pipe(
        takeUntil(this.destroy$),
        pairwise()
      )
      .subscribe(([previous, acuedoSelected]) => {
      
        if (acuedoSelected.statusTema === "eliminarTema") {
          const acuerdo: IAcuerdo = {
            ...acuedoSelected.acuerdo,
            expanded: false,
          };
          this.toggleRow(acuerdo, "");
          this.loadingService.show();
        }
        if (
          acuedoSelected.status === "editTemaAcuerdo"
        ) {
          this.temaModificado = acuedoSelected.ultimoTemaGuardado ?? null;

          const acuerdo: IAcuerdo = {
            ...acuedoSelected.acuerdo,
            expanded: false,
          };

          this.toggleRow(acuerdo, "editTemaAcuerdo");
          this.loadingService.show();
        }
      });

    this.temasUsuario$ = this.store.select(selectTemasUsuario);
    this.temasUsuario$.subscribe((temasData: any) => {
      this.rolesUsuario = temasData;
    });

    this.tipoAcuerdo$ = this.store.select(selectTipoAcuerdo);
    this.tipoAcuerdo$.subscribe((tipoAcuerdo) => {
      this.acuerdoSeleccionado = undefined;
      this.tipoAcuerdo = tipoAcuerdo;
    });
    this.selectStatusAcuerdo$ = this.store.select(selectStatusAcuerdo);
    this.selectStatusAcuerdo$.subscribe((status) => {
      if (status === "") {
        this.acuerdoSeleccionado = undefined;
      }
    });
    this.catTipoTema = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_TEMA)
    );
    this.catCategorizacion = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(
        this.acuerdoMrbService.cats.CATEGORIZACION
      )
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showDetalle(element: any) {
    this.elemmentID = element.position;
    this.element = element;
  }
  hideDetalle() {
    this.element = null;
    this.elemmentID = null;
  }

  async toggleRow(element: IAcuerdo, tipoAccion?: string) {
    this.fechaSeleccionada = "";
    const acuerdoId = element.idFE;
    let selectedAcuerdoById$: Observable<IAcuerdo | undefined>;
    this.store.dispatch(expandAcuerdo({ idAcuerdo: element.idFE }));

    switch (this.tipoAcuerdo) {
      case 1:
        selectedAcuerdoById$ = this.store
          .select(selectAcuerdoActualById(acuerdoId))
          .pipe(take(1));
        break;
      case 2:
        selectedAcuerdoById$ = this.store
          .select(selectAcuerdoById(acuerdoId))
          .pipe(take(1));
        break;
      case 3:
        selectedAcuerdoById$ = this.store
          .select(selectAcuerdoHistoricoById(acuerdoId))
          .pipe(take(1));
        break;
      default:
        return;
    }
    try {
      const acuerdo = await firstValueFrom(selectedAcuerdoById$);

      if (acuerdo) {
        const acuerdoActualizado = {
          ...acuerdo,
          observaciones: element.observaciones,
          esRealizado: element.esRealizado,
        };
        this.getDetalle(acuerdoActualizado, tipoAccion);
      }
    } catch (error) {
      console.error("Error al obtener acuerdo por ID:", error);
    }
  }
  getDetalle(acuerdo: IAcuerdo | undefined, tipoAccion?: string) {
    this.acuerdoSeleccionado = acuerdo;
    if (acuerdo) {
      if (acuerdo.expanded || tipoAccion === "editTemaAcuerdo") {
        this.loadingService.show();
        this.getFilesAndTemas(acuerdo);
      }
    } else {
      this.acuerdoSeleccionado = undefined;
      this.temaModificado = null;
    }
  }

  getIndex(element: any, dataSource: any[]): number {
    return dataSource.indexOf(element) + 1;
  }
  openPicker(picker: MatDatepicker<Date>, element: any) {
    picker.open();
  }
  // Function to format date for display
  parseDate(dateString: string): Date {
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.add(1, "days");
    const localDate = adjustedDate.local();
    return localDate.toDate();
  }

  parseDateSpanish(dateString: string): string {
    moment.locale("es");
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.add(1, "days");
    const localDate = adjustedDate.local();
    return localDate.format("D MMMM YYYY");
  }
  onDateChange(event: any, element: any) {
    this.fechaSeleccionada = event.value;
    const selectedDate: Date = event.value;
    const formattedDate: string = selectedDate.toISOString();

    this.store.dispatch(
      updateFechaAcuerdo({
        fecha: formattedDate,
        acuerdo: { ...element, expanded: true, fechaAcuerdo: formattedDate },
      })
    );
  }
  downloadPDF(element: any): void {
    this.getDetalleAcuerdo(element).subscribe((data) => {
      if (data.length > 0) {
        this.createDawnloadFile.createHTMLTemplate(data);
      } else if (data.length == 0) {
         this.loadingService.hide();
        this.showModal(
          "Error",
          "No existe detalle para este acuerdo.",
          true,
          false
        );
        
      }
     
    });
  }

  getDetalleAcuerdo(element: any): Observable<any> {
    this.loadingService.show();

    return this.acuerdosService.detalleAcuerdo(element.idFE).pipe(
      switchMap((data) => {
        if (data.error) {
          return of([]);
        } else {
          return of(data.temas);
        }
      }),
      catchError((error) => {
        return of([]);
      })
    );
  }

  getTemas(acuerdo: IAcuerdo, tipoDescarga: number) {
    this.loadingService.show();

    this.acuerdosService.detalleAcuerdo(acuerdo.idFE).subscribe((data) => {
      if (data && !data.error && data.temas && data.temas.length > 0) {
        this.downloadByTipo(tipoDescarga, data.temas, acuerdo);
      } else {
        this.loadingService.hide();
        const subtitle =
          tipoDescarga == 1
            ? "No existe detalle para este acuerdo."
            : "No se encontrarón temas para este acuerdo.";
        const title = tipoDescarga == 1 ? "Error" : "Atención";
        this.showModal(title, subtitle, true, false);
      }
    });
  }

  downloadByTipo(tipoDescarga: number, temas: any, acuerdo: IAcuerdo) {
    if (tipoDescarga == 1) {
      this.downloadZIPFiles(temas);
    } else {
      this.downloadListaTemas(acuerdo);
    }
  }

  downloadZIPFiles(temas: any) {
    const descargas: IDescargas | undefined = this.filtrarTemas(temas);
    if (descargas) {
      this.acuerdosService
        .downloadZIPFilesTemas(descargas)
        .subscribe((data) => {
          if (data.error) {
            this.loadingService.hide();
          } else {
            let ifrm = document.createElement("iframe");
            ifrm.setAttribute("src", data);
            ifrm.setAttribute("id", "temporaryIframe");
            ifrm.style.width = "0px";
            ifrm.style.height = "0px";
            ifrm.style.border = "0";
            document.body.appendChild(ifrm);

            setTimeout(() => {
              const iframeElement = document.getElementById("temporaryIframe");
              if (iframeElement) {
                document.body.removeChild(iframeElement);
              }
            }, 5000);
            this.loadingService.hide();
          }
        });
    }
  }

  downloadListaTemas(acuerdo: IAcuerdo) {
    const listaTemas: IListaTemas = {
      fechaAcuerdo: acuerdo.fechaAcuerdo,
      idFormaEnvio: acuerdo.idFE,
      temasUsuario: this.rolesUsuario,
    };
    this.acuerdosService.downloadListaTemas(listaTemas).subscribe((res) => {
      if (!res.error) {
        this.download(res.data, acuerdo.fechaAcuerdo);
      } else {
        this.showModal(
          "Alerta",
          "Ocurrio un error inesperado, intente nuevamente.",
          true,
          false
        );
      }
    });
  }

  filtrarTemas(temas: IDetalleTema[]): IDescargas | undefined {
    const { rolesLectura } = getUserRoles(this.rolesUsuario);

    //FILTRAMOS TEMAS CONFIDENCIALES
    const temasConfidenciales = temas.filter(
      (item) => rolesLectura.indexOf(item.categorizacion) === -1
    );
    const entradasConfidenciales = temasConfidenciales.reduce(
      (initial: any[], item) => {
        let entradas = item.entradas;
        return initial.concat(entradas);
      },
      []
    );
    const archivosConfidenciales = entradasConfidenciales.reduce(
      (initial, item) => {
        let archivos = item.archivos;
        return initial.concat(archivos);
      },
      []
    );
    //FILTRAMOS TEMAS A LEER
    const temasLeer = temas.filter(
      (item) => rolesLectura.indexOf(item.categorizacion) !== -1
    );
    let entradasLeer = temasLeer.reduce((initial: any[], item) => {
      let entradas = item.entradas;
      return initial.concat(entradas);
    }, []);
    let archivosLeer = entradasLeer.reduce(function (initial: any[], item) {
      if (rolesLectura.indexOf(item.idCategorizacion) === -1) {
        initial = initial.concat(item.archivos);
      }
      return initial;
    }, []);
    //FILTRAMOS TEMAS QUE PUEDE LEER
    const temas_lectura = temas.filter(
      (item) => rolesLectura.indexOf(item.categorizacion) !== -1
    );
    const temas__entradas_lectura: todosEntrada[] = temas_lectura.map(
      (item) => {
        let archivos: any = [];
        let entradas = item.entradas;

        for (let index in entradas) {
          //FILTRAMOS ENTRADAS QUE PUEDE LEER
          if (rolesLectura.indexOf(entradas[index].idCategorizacion) !== -1) {
            archivos = archivos.concat(entradas[index].archivos);
          }
        }

        return {
          id: item.id,
          indiceTema: item.indiceTema + 1,
          categorizacion: item.categorizacion,
          fechaAcuerdo: item.fechaAcuerdo
            .substr(0, 10)
            .split("-")
            .reverse()
            .join(""),
          archivos: archivos,
        };
      }
    );

    //FILTRAMOS SOLO TEMAS CON ARCHIVOS
    const temas_solo_archivos = temas__entradas_lectura.filter(
      (item) => item.archivos.length !== 0
    );

    ////////////////////////////////////////
    //MENSAJES - VALIDACIONES PARA DESCARGAS
    ////////////////////////////////////////
    if (temas_solo_archivos.length === 0) {
      if (archivosConfidenciales.length > 0 || archivosLeer.length > 0) {
        this.loadingService.hide();
        this.showModal(
          "Alerta",
          "Estimado usuario, usted no cuenta con permisos para visualizar los archivos adjuntos.",
          true,
          false,
          680
        );
      } else {
        this.loadingService.hide();
        this.showModal(
          "Alerta",
          " No existen archivos para descargar.",
          true,
          false
        );
      }

      return;
    } else {
      console.log("");
    }

    let descargas: IDescargas = { folder: "", files: [] };
    for (let key in temas_solo_archivos) {
      let indice = temas_solo_archivos[key].indiceTema;
      let archivos = temas_solo_archivos[key].archivos;
      let fechaAcuerdo = temas_solo_archivos[key].fechaAcuerdo;

      descargas.folder = "Acuerdo Mr B del " + fechaAcuerdo;

      for (let i in archivos) {
        let sub_indice = parseInt(i) + 1;
        let archivo = archivos[i];

        let nombre_corto = archivo.nombre_archivo;
        if (nombre_corto.length >= 120) {
          nombre_corto =
            "NAMETOOLONG..." +
            nombre_corto.substring(
              nombre_corto.length - 100,
              nombre_corto.length
            );
        }

        let file = {
          nombre_corto: nombre_corto,
          nombre_indice: indice + " - " + sub_indice + " - " + nombre_corto,
          fileName: archivo.nombre_archivo,
          filePathBucket:
            "entradas/" + archivo.id_entrada + "/" + archivo.nombre_archivo,
        };

        descargas.files.push(file);
      }
    }

    return descargas;
  }

  formatFecha(fecha: Date | string): string {
    let date: Date;

    if (typeof fecha === "string") {
      date = new Date(fecha);
    } else {
      date = fecha;
    }

    const day = ("0" + date.getUTCDate()).slice(-2);
    const month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
    const year = date.getUTCFullYear();

    return `${day}${month}${year}`;
  }

  async getFilesAndTemas(acuerdo: IAcuerdo) {
      this.loadingService.show();
      const detalleAcuerdo = await firstValueFrom(
        this.acuerdosService.detalleAcuerdo(acuerdo.idFE)
      );
    
    
      let temas = detalleAcuerdo.error ? [] : detalleAcuerdo.temas;
      if (detalleAcuerdo.error) {
        this.temas = [];
        this.temaModificado = null;
        this.initializeForms([], acuerdo);
        this.store.dispatch(
          cargaTemasAcuerdo({
            acuerdoSeleccionado: {
              acuerdo,
              temas: [],
              archivos:[],
              status: "",
              statusTema: "",
              ultimoTemaGuardado: null,
            },
          })
        );
        // this.dialog.closeAll();
        this.showModal(
          "Alerta",
          "No existe detalle para este acuerdo.",
          true,
          false
        );
      } else {

        if (this.temaModificado !== null) {
          temas = temas.map((tema: any,index:number) => {
            if (
              (typeof this.temaModificado === "number" ||
                typeof this.temaModificado === "string") &&
              ((Number(tema.indiceTema) === this.temaModificado &&
                this.showTema(tema)) ||
                (tema.id === this.temaModificado && this.showTema(tema)))
            ) {
              return {
                ...tema,
                expanded: true,
                nuevoTema: false,
                indiceTema: index,
              };
            } else {
              return {
                ...tema,
                expanded: false,
                nuevoTema: false,
                indiceTema: index,
              };
            }
          });
        } else {
          temas = temas.map((tema: any,index:number) => {
            tema.expanded = false;
            tema.nuevoTema = false;
            tema.indiceTema=index
            return tema;
          });
          console.log(" detalle tema con index actualizado", temas);
          
        }

        this.temaModificado = null;    
        this.initializeForms(temas, acuerdo);
       
        
        this.store.dispatch(
          cargaTemasAcuerdo({
            acuerdoSeleccionado: {
              acuerdo,
              temas,
              archivos:[],
              status: "",
              ultimoTemaGuardado: null,
            },
          })
        );
        this.store.dispatch(cargarEntradas());
      }
    this.loadingService.hide();
  }

  showModal(title: string, message: string, accept: boolean, cancel: boolean,width?:number) {


    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: width ? `${width}px` : "450px",
      data: {
        title,
        message,
        showButtons: {
          accept,
          cancel,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
     
    });
  }
  download(data: BlobPart, fechaAcuerdo: string) {
    const fechaFormateada = this.parseDateSpanish(fechaAcuerdo);
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    const fileName = `Temas para acuerdo con Mr B (${fechaFormateada}).docx`;
    var link = document.createElement("a");

    link.id = `file1`;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById("file1");
      elements?.remove();
    }, 2000);
    this.loadingService.hide();
  }

  //cammbos form global
  initializeForms(temas: IDetalleTema[], acuerdo: IAcuerdo) {
    const temasFormArray = this.fb.array(this.acuerdosUtils.createFormGroupTemas(temas,this.catCategorizacion,this.catTipoTema));
    const acuerdoFormGroup = this.fb.group(
      this.createAcuerdoFormGroup(acuerdo)
    );
    this.temasAcuerdo.setControl("temas", temasFormArray);
    this.temasAcuerdo.setControl("acuerdo", acuerdoFormGroup);
  }

  createFormGroup(temas: IDetalleTema[]): FormGroup[] {
    const user = this.stateUser.state().usuario;

    console.log("temas", temas);
    
    if (temas.length > 0) {
      return temas.map((tema) => {
        return this.fb.group({
          idTema: [tema.id],
          nombreTema: [
            {
              value: tema.nombreTema,
              disabled:
                (!this.getPermisoEscritura(tema.categorizacion) &&
                  !tema.nuevoTema) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          descripcionTema_html: [
            {
              value: tema.descripcionTema_html,
              disabled:
                (!this.getPermisoEscritura(tema.categorizacion) &&
                  !tema.nuevoTema) ||
                this.esHistorico(),
            },
            [Validators.required],
          ],
          accion: [
            {
              value: "",
              disabled: !(
                this.puedeEditar(tema) && this.getEsResponsable(tema)
              ),
            },
          ],
          respAnalista: [
            {
              value: tema.respAnalista,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          respCoordinador: [
            {
              value: tema.respCoordinador,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          respSupervisor: [
            {
              value: tema.respSupervisor,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          esAprobado: [
            {
              value: tema.esAprobado,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [Validators.required],
          ],
          tipoTema: [
            {
              value: this.getDefaultTipoTema(tema.tipoTema),
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],

          esConfidencial: [
            {
              value: tema.esConfidencial,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico() ||
                !this.acuerdosUtils.enabledConfidencial(this.catCategorizacion),
            },
            [Validators.required],
          ],
          id_categoria: [
            {
              value: tema.nuevoTema ? null : tema.id_categoria,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          categorizacion: [
            {
              value: this.getDefaultCategorizacion(tema.categorizacion),
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          esImpreso: [
            {
              value: tema.esImpreso,
              disabled:
                !(this.puedeEditar(tema) && this.getEsResponsable(tema)) ||
                this.esHistorico(),
            },
            [Validators.required],
          ],
          entradas: [tema.entradas],
          indiceTema: [tema.indiceTema],
          expanded: [tema.expanded],

          entradaSelected: [
            {
              value: "",
              disabled: this.esHistorico() || !this.puedeEditar(tema),
            },
          ],
          indicacion: [
            {
              value: "",
              disabled: tema.edoTema == 3 || !this.puedeEditar(tema),
            },
            [this.requiredWhenTouchedValidator()],
          ],
          indicacionesAB: [tema.indicacionesAB, [Validators.required]],
          nuevoTema: [tema.nuevoTema],
          fechaAcuerdo: [tema.fechaAcuerdo],
          edoTema: [tema.edoTema],
          id: [tema.id],
          //parra nuevos temas obtener noommbre para
          nombreAnalista: [""],
          nombreSupervisor: [""],
          nombreCoordinador: [""],
          id_categorizacion: [
            this.getDefaultCategorizacion(tema.categorizacion),
          ],
          nombreUsuario: [user.nombre],
          //si no tiene persmisos desabilitar
          showDetalleTema: [this.showTema(tema)],
          showConfidencial: [this.showConfidencial(tema)],
          numEntregables: [this.getNumeroEntregables(tema)],
          editorInstanceId: ["editorInstanceId-" + tema.indiceTema],
        });
      });
    }
    return [];
  }

  requiredWhenTouchedValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return control.dirty && !control.value
        ? { requiredWhenTouched: true }
        : null;
    };
  }

  createAcuerdoFormGroup(acuerdo: IAcuerdo): FormGroup {
    return this.fb.group({
      esRealizado: [acuerdo.esRealizado ?? false],
      expanded: [acuerdo.expanded ?? false],
      fechaAcuerdo: [acuerdo.fechaAcuerdo ?? ""],
      idFE: [acuerdo.idFE ?? ""],
      observaciones: [acuerdo.observaciones ?? ""],
      temas: [acuerdo.temas ?? []],
      urlUnico: [acuerdo.urlUnico ?? ""],
    });
  }

  getPermisoEscritura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.escritura.includes(categorizacionTema);
  };

  getPermisoLectura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.lectura.includes(categorizacionTema);
  };

  esHistorico(): boolean {
    const tipoAcuerdo = structuredClone(
      this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo
    );
    return tipoAcuerdo === 3;
  }
  getEsResponsable(tema: IDetalleTema) {
    const user = this.stateUser.state().usuario;
    const esResponsable = [
      tema.respAnalista,
      tema.respCoordinador,
      tema.respSupervisor,
    ].includes(user.uid);

    return esResponsable;
  }
  esResponsableNuevoTema(tema: IDetalleTema) {
    return (
      (!this.getEsResponsable(tema) && !tema.nuevoTema) || this.esHistorico()
    );
  }
  getDefaultTipoTema(tipoTema: number): number | null {
    if (this.catTipoTema.length > 0) {
      if (tipoTema && this.catTipoTema.some((item) => item.id === tipoTema)) {
        return tipoTema;
      } else {
        return this.catTipoTema[0].id;
      }
    } else {
      return null;
    }
  }

  getDefaultCategorizacion(idCat: string): string | null {
    if (!idCat) {
      return this.catCategorizacion[0].id;
    }

    if (this.catCategorizacion.length > 0) {
      if (idCat && this.catCategorizacion.some((item) => item.id === idCat)) {
        return idCat;
      } else {
        return this.catCategorizacion[0].id;
      }
    } else {
      return null;
    }
  }
  puedeEditar(tema: IDetalleTema): boolean {
    const nuevoTema = tema.nuevoTema;
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    //return (nuevoTema || (soloEscritura && soloLecura)) && !this.esHistorico();
    return nuevoTema || soloEscritura;
  }
  showTema = (tema: IDetalleTema): boolean => {
    const nuevoTema = tema.nuevoTema;
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    return nuevoTema || soloLecura || (soloLecura && soloEscritura);
  };

  showConfidencial(tema: IDetalleTema): boolean {
    const soloLecura = this.getPermisoLectura(tema.categorizacion);
    const soloEscritura = this.getPermisoEscritura(tema.categorizacion);
    const nuevoTema = tema.nuevoTema ?? false;
    return !soloLecura && soloEscritura && !nuevoTema;
  }

  getNumeroEntregables(tema: IDetalleTema): number {
    let numEntregables = 0;

    if (tema.entradas.length == 0) {
      return 0;
    }
    tema.entradas.forEach((entrada) => {
      if (entrada.entregables && entrada.entregables.length > 0) {
        numEntregables += entrada.entregables.length;
      }
    });

    return numEntregables;
  }
}

export interface IDescargas {
  folder: string;
  files: any[];
}
